import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["locationFields", "calendarSelect"]

  connect() {
    console.log("Scheduling Meeting Type controller connected")
    // Initialize calendar dropdown on page load
    this.updateCalendarOptions()
  }

  // Show/hide location-specific fields based on selected location type
  updateLocationFields(event) {
    const selectedType = event.target.value
    const locationFieldsContainer = this.locationFieldsTarget

    // Hide all location-specific fields
    const allFields = locationFieldsContainer.querySelectorAll('[data-location-type]')
    allFields.forEach(field => {
      field.style.display = 'none'
    })

    // Show the selected location type's fields
    const selectedField = locationFieldsContainer.querySelector(`[data-location-type="${selectedType}"]`)
    if (selectedField) {
      selectedField.style.display = 'block'
    }

    // Update calendar dropdown based on new location type
    this.updateCalendarOptions()
  }

  updateCalendarOptions() {
    if (!this.hasCalendarSelectTarget) return

    const calendarSelect = this.calendarSelectTarget
    const calendarsData = JSON.parse(calendarSelect.dataset.calendars || '[]')
    const selectedId = calendarSelect.dataset.selectedId
    const currentValue = calendarSelect.value || selectedId
    const defaultProvider = calendarSelect.dataset.defaultProvider

    // Get selected location type
    const locationTypeRadio = this.element.querySelector('input[name="scheduling_meeting_type[location_type]"]:checked')
    const locationType = locationTypeRadio ? locationTypeRadio.value : null

    // Filter calendars based on location type
    let filteredCalendars = calendarsData
    let showDefaultOption = true

    if (locationType === 'teams') {
      filteredCalendars = calendarsData.filter(cal => cal.provider === 'microsoft')
      // Only show default option if default calendar is Microsoft
      showDefaultOption = defaultProvider === 'microsoft'
    } else if (locationType === 'google_meet') {
      filteredCalendars = calendarsData.filter(cal => cal.provider === 'google')
      // Only show default option if default calendar is Google
      showDefaultOption = defaultProvider === 'google'
    }

    // Rebuild the select options
    calendarSelect.innerHTML = ''

    // Add "Use default calendar" option only if it's compatible
    if (showDefaultOption) {
      const defaultOption = document.createElement('option')
      defaultOption.value = ''
      defaultOption.text = 'Use default calendar'
      calendarSelect.appendChild(defaultOption)
    }

    filteredCalendars.forEach(cal => {
      const option = document.createElement('option')
      option.value = cal.id
      option.text = cal.label
      if (cal.id.toString() === currentValue) {
        option.selected = true
      }
      calendarSelect.appendChild(option)
    })

    // If the current selection is not valid, select the first available calendar
    if (currentValue && !filteredCalendars.find(cal => cal.id.toString() === currentValue)) {
      if (showDefaultOption) {
        calendarSelect.value = ''
      } else if (filteredCalendars.length > 0) {
        calendarSelect.value = filteredCalendars[0].id
      }
    }
  }
}
